export const CF2_ROLES = ['EC', 'OM', 'RM', 'SC', 'SCM', 'SCO', 'SM', 'HD', 'SSM', 'AUD', 'BJO'] as const;
export const CF2_APP_ROLES = {
  user: [...CF2_ROLES],
  admin: ['HD'],
};
